/* @flow */
/* global google */

import React, { Component } from 'react';
import { Message, Segment, Label } from 'semantic-ui-react';
import { ADDRESS_MAP_BLOCKTYPE } from './constants';

type Props = {
  block?: EditorialTextBlock,
};

class View extends Component {
  props: Props;

  componentDidMount() {
    const { block } = this.props;
    const { order } = block;

    if (document.getElementById(`map_view_${order}`)) {
      const map: Object = new google.maps.Map(
        document.getElementById(`map_view_${order}`),
        {
          center: { lat: block.lat, lng: block.lng },
          zoom: block.zoomLevel || 11,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          draggable: false,
          keyboardShortcuts: false,
          scrollwheel: false,
        }
      );

      new google.maps.Marker({
        position: { lat: block.lat, lng: block.lng },
        map,
      });
    }
  }

  render() {
    const { block } = this.props;
    const { order } = block;
    const label = block.type === ADDRESS_MAP_BLOCKTYPE
      ? 'Adresse'
      : 'Destination';
    const mapAttachment = block.address ? 'bottom' : false;

    if (block.lat && block.lng) {
      return (
        <div>
          <Segment attached="top">
            <Label attached="top right">{label}</Label>
            {block.address}
          </Segment>
          <Segment attached={mapAttachment}>
            <div
              id={`map_view_${order}`}
              className="ui item content"
              style={{ height: '400px', width: '100%' }}
            />
          </Segment>
        </div>
      );
    }

    return <Message icon="info" header={`Aucune ${label} spécifiée`} />;
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/address/View.js